module.exports = __webpack_public_path__ + "img/LOGO-BCC.a7cb90ba.png";